import { ICheckbookCard } from "@wingspanhq/payments/dist/interfaces";
import { debitCardBrandNameMap } from "../constants/bankCard";

export const selectorDebitCardBrand = (debitCard: ICheckbookCard) =>
  debitCardBrandNameMap[debitCard.brand];
